export default __webpack_public_path__ + "static/media/slider0.59d130ef.jpg";